/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=b77b9104&scoped=true&"
import script from "./language-selector.vue?vue&type=script&lang=js&"
export * from "./language-selector.vue?vue&type=script&lang=js&"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=b77b9104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77b9104",
  null
  
)

export default component.exports